<template>
  <div class="header">
    <div class="back" title="Назад" @click="goBack"><img src="../image/back.png"></div>
    <div class="exit" title="Выйти" @click="logout"><img src="../image/exit.svg"></div>
    <div class="user">
      <div class="name">{{ userName }}</div>
      <div class="role">{{ userRole }}</div>
    </div>
    <div class="notice">
      <img src="../image/alarm.svg">
      <span class="numb">3</span>
    </div>
    <div v-if="!hasRole(['ROLE_HR'])" class="add-request">
      <router-link to="/orders/new">
        <button type="button">Новый заказ</button>
      </router-link>
    </div>
  </div>
</template>

<script>
  import api from '../api'
  import utils from '../utils'

  const hideHeaderOnScrollTop = 150;
  let hideHeaderInterval;

  export default {
    computed: {
      userName() {
        return this.$store.getters.username
      },

      userRole() {
        return this.$store.getters.roleName
      },
    },

    methods: {
      goBack() {
        if (this.$route.name === 'Order' && this.$route.params.id !== 'new') {
          this.$router.push('/orders')
        }
        else {
          this.$router.go(-1)
        }
      },

      logout() {
        api.logout()
        this.$router.push('/')
      },

      hasRole(accessForRoles) {
        return utils.checkRole(this.$store.getters.roleCode, accessForRoles)
      }
    },

    mounted() {
      document.body.classList.remove('page-without-header');
      if (hideHeaderInterval)
        clearInterval(hideHeaderInterval);

      if (['WorkersBase'].indexOf(this.$route.name) != -1) {
        let scrollTopEl = document.getElementsByClassName('page-scroll')[0];

        hideHeaderInterval = setInterval(() => {
          let scrollTop = scrollTopEl ? scrollTopEl.scrollTop : 0;

          if (scrollTop > hideHeaderOnScrollTop) {
            document.body.classList.add('page-without-header')
          } else {
            document.body.classList.remove('page-without-header')
          }
        }, 1000);
      }
    },
  }
</script>
